export enum PictureBasicCardEnum {
    card,
    icon,
    img,
}